/**
 * Email Templates API namespace.
 *
 * Follows the per-domain barrel migration direction (services/apiClient.js +
 * services/<domain>/api.js), re-exported from the back-compat barrel
 * services/api.js. Each method returns the axios promise.
 *
 * The `render` method is the seam for the future "Send directly" feature: the
 * server returns { subject, bodyText, bodyHtml } — the same shape the backend
 * graphMailService.sendMail() consumes — so adding a `send` method later is a
 * thin addition here, not a rework.
 */
import api from '../apiClient';

export const emailTemplateAPI = {
  // Gallery + filters. params: { module, category, includeInactive }
  getAll: (params) => api.get('/email-templates', { params }),
  getById: (id) => api.get(`/email-templates/${id}`),

  // Placeholder registry + category/group metadata that drives the composer UI.
  getPlaceholders: () => api.get('/email-templates/placeholders'),

  // Server-authoritative render (used for copy/send; the live preview renders
  // locally). Body: { templateId?, subject?, body?, values }
  render: (payload) => api.post('/email-templates/render', payload),

  // Library management (admin/manager only, enforced server-side).
  create: (data) => api.post('/email-templates', data),
  update: (id, data) => api.put(`/email-templates/${id}`, data),
  delete: (id) => api.delete(`/email-templates/${id}`),
};

export default emailTemplateAPI;
